export const VIEW_TYPES = {
    CHART: 'chartView',
    TABLE: 'tableView'
};
